<template>
  <DateSegments
    :id="`dynamicInput-${inputData.id}`"
    :date-help-text="addNbsp(getLocaleText(inputData.help))"
    :date-label="addNbsp(getLocaleText(inputData.label))"
    :required="inputData.required"
    :min-value="inputData.minValue"
    :max-value="inputData.maxValue"
    :value.sync="inputValue"
    :identifier="inputData.id"
    class="text-left"
    @input="updateValue($event)"
    @blurPart="
      sendGtmEvent(`${inputData.label.find(lbl => lbl.language === 'cs')?.text}_${$event}`)
    "
  />
</template>

<script>
import formGtm from '@/mixins/formGtm';
import date from '@/mixins/date';
export default {
  name: 'UlDateSegmented',
  mixins: [formGtm, date],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: ''
    };
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    }
  },
  watch: {
    responses() {
      if (this.responses[this.formName][this.inputData.id]) {
        this.inputValue = this.responses[this.formName][this.inputData.id];
      }
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    this.inputValue = this.responses[this.formName][this.inputData.id] || this.inputValue;

    if (this.inputValue) {
      this.updateValue(this.inputValue);
    }
  },

  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$eventHub.$emit(`validateDateSegments_${this.inputData.id}`, result => {
        this.$store.commit('dynamicForms/updateValidation', {
          id: this.inputData.id,
          value: result,
          formName: this.formName
        });
      });
    },
    reset() {
      this.$eventHub.$emit(`resetDateSegmentsValidation_${this.inputData.id}`);
    },
    updateValue(date) {
      this.validate();
      let newValue = date.length ? date : null;

      const updateResponsePayload = {
        id: this.inputData.id,
        value: newValue,
        formName: this.formName
      };

      this.$store.dispatch('dynamicForms/updateResponse', updateResponsePayload);
    }
  }
};
</script>
